import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./settings-window.css"
import { getGlobalTextSizeStyle, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';

class SettingsWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'accessibility-disabled',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/accessibility-enabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'download',
				src: process.env.PUBLIC_URL + '/assets/images/download.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

export const settingsWindowCaching = new SettingsWindowCaching();

const SettingsWindow = (props: SettingsWindowConfig) => {
	const root = useRef(null);
	
	const [focusSet, setFocusSet] = useState(false);
	if(!focusSet) {
		setTimeout(() => {
			setFocus('settings-window-top');
		}, 1000);
		setFocusSet(true);
	}
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	return (
		<div ref={root} className={"modal-disable-select center-element settings-window-container " + props.animation.getInitialClass()} style={{
			position: 'relative'
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: settingsWindowCaching.getItemByKey('accessibility-disabled').src,
						idFor508: 'settings-window-top',
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Accessibility",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: () => {
							setLast508WindowId('settings-window-top');
							props.onAccessibilityClicked()
						}
					},
					{
						imgSrc: settingsWindowCaching.getItemByKey('download').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Pre-Load Assets",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: () => {
							setLast508WindowId('settings-window-top');
							props.onPreloadClicked()
						}
					},
					{
						imgSrc: settingsWindowCaching.getItemByKey('return1').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Return to Main Menu",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReturnToMainMenu
					}
				]}
				onRenderContent={() => {
					return (
						<p className='default-text center-element-horizontal white-text' style={{
							textAlign:'center',
							width: '100%',
							...getGlobalTextSizeStyle(TextHtmlTagType.p)
						}}>
							<span className='title-text2 white-text'>Settings</span><br />
							<br />
							Please select an option:
						</p>);
				}}></PopUp1>
		</div>
	);

};

export interface SettingsWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onAccessibilityClicked: () => void;
	onPreloadClicked: () => void;
	onReturnToMainMenu: () => void;
}

export default SettingsWindow;